import { render } from "./WalletUtilisation.vue?vue&type=template&id=b535440e&scoped=true&ts=true"
import script from "./WalletUtilisation.vue?vue&type=script&lang=ts"
export * from "./WalletUtilisation.vue?vue&type=script&lang=ts"

import "./WalletUtilisation.vue?vue&type=style&index=0&id=b535440e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b535440e"]])

export default __exports__